import { useRef } from 'react'
import { useDateSegment } from '@react-aria/datepicker'
import { DateSegment as DateSegmentType, TimeFieldState } from '@react-stately/datepicker'
import Styles from './TimePicker.module.scss'

export function DateSegment({ segment, state }: { segment: DateSegmentType; state: TimeFieldState }) {
  const ref = useRef(null)
  const { segmentProps } = useDateSegment(segment, state, ref)

  return (
    <div
      {...segmentProps}
      ref={ref}
      className={Styles.segment}
      style={{
        ...segmentProps.style,
        minWidth: segment.maxValue != null ? String(segment.maxValue).length + 'ch' : undefined,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          display: segment.isPlaceholder ? '' : 'none',
          height: segment.isPlaceholder ? '' : 0,
          pointerEvents: 'none',
        }}
      >
        {segment.placeholder}
      </span>
      {segment.isPlaceholder ? '' : segment.text}
    </div>
  )
}
